import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function LoadsLayout({ children }: { children: React.ReactNode }) {
  const { t: tLoads } = useTranslation("loads");

  return (
    <>
      <PageTitle>{tLoads("title")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/loads")({
  component: function LayoutRoute() {
    return (
      <LoadsLayout>
        <Outlet />
      </LoadsLayout>
    );
  },
});
